import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import Plbscf要約表示Mixin from '@/entries/user/mixins/Plbscf要約表示Mixin';

import { PlbscfListItemConfig } from '@/master/Plbscf';

export default mixins(Plbscf要約表示Mixin).extend({
  name: 'PlbscfTableRow',

  props: {
    config: {
      type: Object as PropType<PlbscfListItemConfig>,
      required: true,
    },
    categoryExists: {
      type: Boolean,
      default: false,
    },
  },
});
